app.controller("SubjectSyllabusController", ["$scope", "Subject", "Lecturer", "GradeTemplate", "StaticData", "SyllabusService", "$timeout", "$state", "$stateParams", "usSpinnerService", "toastr", "InfoModal", "ConfirmModal", "AuthService", "$uibModal",
    function ($scope, Subject, Lecturer, GradeTemplate, StaticData, SyllabusService, $timeout, $state, $stateParams, usSpinnerService, toastr, InfoModal, ConfirmModal, AuthService, $uibModal) {
        $scope.data = null;
        $scope.subjectId = $stateParams.subjectId;
        $scope.action = $stateParams.action;
        $scope.message = 'სილაბუსი რედაქტირების რეჟიმშია';
        $scope.myVersion = false;
        $scope.subjectName = '';
        $scope.syllabus = {
            subject: {},
            programName: null,
            authors: [],
            // lecturers: [],
            lectureTime: null,
            seminarTime: null,
            laboratoryTime: null,
            quizzes: null,
            finalExam: null,
            homework: null,
            dependencies: null,
            purpose: null,
            result: null,
            teachingMethods: null,
            gradeTemplate: null,
            evaluationMethod: null,
            contentsOfCourse: null,
            mainLiterature: null,
            supportingLiterature: null,
            additionalInfo: null
        };
        $scope.author = {};
        // $scope.lecturer = {};
        $scope.authors = [];
        // $scope.lecturers = [];

        var oldTemplate = null;
        $scope.showMessage = false;
        $scope.tinymceOptions = {

        };
        $scope.disabledTiny = {
            disabled: true,
            menubar: false,
            plugins: 'autoresize',
            toolbar: true,
            toolbar: 'compareButton',
            setup: function (editor) {
                editor.ui.registry.addButton('compareButton', {
                    // html: '< i class= "material-icons" > compare_arrows</i ></button >',
                    icon: 'restore-draft',
                    tooltip: 'ცვლილების ნახვა',
                    onAction: function (_) {
                        var cont = editor.getContent();
                        if ($scope.action == 'review')
                            Object.keys($scope.data.editRequest).forEach(function (e) {
                                if ($scope.data.editRequest[e] == cont) {
                                    $scope.changeDialog($scope.data[e] || "", cont || "")
                                }
                            })
                    },
                });

            }
        };

        $scope.enabledTiny = {
            selector: "textarea",
            plugins: 'autoresize link code table lists wordcount visualchars visualblocks nonbreaking',
            toolbar: 'compareButton undo redo | fontselect fontsizeselect | bold italic underline strikethrough forecolor backcolor | blockquote subscript superscript | alignleft aligncenter alignright | numlist bullist| code | table | removeformat | wordcount visualchars visualblocks nonbreaking',
            fontsize_formats: '8px 10px 12px 14px 18px 24px 36px'
        };

        $scope.tinymceOptions = $scope.enabledTiny;

        $scope.loaded = false;
        $scope.disableFields = false;

        loadPage();

        function loadPage(page, cb) {
            usSpinnerService.spin("root");
            SyllabusService.getBySubject({
                subjectId: $scope.subjectId
            }).then(function (data) {
                if (data) {
                    $scope.data = data;
                    $scope.syllabus = data;
                    $scope.subjectName = data.subject.name;
                    oldTemplate = data.subject.gradeTemplate;
                    if (data.editRequest && data.editRequest.subject.gradeTemplate != oldTemplate) {
                        $scope.showMessage = true;
                    }
                    if ($scope.action === 'review') {
                        $scope.getMyVersion();
                    } else if ($scope.action === 'edit') {
                        if (data.editRequest && data.editRequest.isSelt) {
                            $scope.getMyVersion();
                        } else {
                            $scope.getLastVersion();
                        }
                    }
                    $scope.prepareFields();

                }
                usSpinnerService.stop("root");
            });
        }

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        $scope.$watch('syllabus.choosenAuthor', function (author) {
            if (author && author._id) {
                $scope.authors.push(author);
                $scope.syllabus.choosenAuthor = null;
            }
        }, true);

        $scope.remove_author = function (id) {
            var el_index = _.findIndex($scope.authors, function (author) {
                return id === author._id;
            });
            $scope.authors.splice(el_index, 1);
        };

        $scope.showComment = function () {
            if ($scope.syllabus.subject.gradeTemplate != oldTemplate) {
                $scope.showMessage = true;
            } else {
                $scope.showMessage = false;
            }
        };

        // $scope.$watch('syllabus.choosenLecturer', function (lecturer) {
        //     if (lecturer && lecturer._id) {
        //         $scope.lecturers.push(lecturer);
        //         $scope.syllabus.choosenLecturer = null;
        //     }
        // }, true);

        // $scope.remove_lecturer = function (id) {
        //     var el_index = _.findIndex($scope.lecturers, function (lecturer) {
        //         return id === lecturer._id;
        //     });
        //     $scope.lecturers.splice(el_index, 1);
        // };

        $scope.$watch('syllabus.subject.prerequisite', function (val) {
            if (val && val._id) {
                if (!$scope.syllabus.subject.prerequisites) {
                    $scope.syllabus.subject.prerequisites = [];
                }
                $scope.syllabus.subject.prerequisites.push(val);
                $scope.syllabus.subject.prerequisite = null;
            }
        }, true);

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({ query: query }).then(function (data) {
                return data.docs.filter(function (subj) {
                    var elementIndex = _.findIndex($scope.syllabus.subject.prerequisites, function (prerequisite) {
                        return prerequisite._id === subj._id;
                    });

                    if ($stateParams.subjectId === subj._id) {
                        return false;
                    }

                    return elementIndex === -1;
                })
            });
        };

        $scope.delete_prerequisite = function (id) {
            var elementIndex = _.findIndex($scope.syllabus.subject.prerequisites, function (dep) {
                return id === dep._id;
            });

            $scope.syllabus.subject.prerequisites.splice(elementIndex, 1);
        };

        StaticData.getItemsByKey("lecturer_ranks").then(function (ranks) {
            $scope.ranks = [{ name: "თანამდებობა" }].concat(ranks);
            $scope.ranksMap = _.keyBy($scope.ranks, '_id');
        });

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({ query: query }).then(function (data) {
                return data.docs;
            });
        };

        GradeTemplate.list().then(function (list) {
            $scope.templates = list;
        });
        $scope.save = function () {
            document.getElementById('something').click();
            window.setTimeout($scope.saveSyllabus, 250);
        };
        $scope.saveSyllabus = function () {
            document.getElementById('something').click();
            if (!$scope.syllabus.subject.gradeTemplate) {
                InfoModal.show({ message: "გთხოვთ მიუთითოთ შაბლონი", title: "შეცდომა" });
                return;
            } else if (!$scope.syllabus.subject.level) {
                InfoModal.show({ message: "გთხოვთ მიუთითოთ საფეხური", title: "შეცდომა" });
                return;
            } else {
                usSpinnerService.spin("root");
                $scope.syllabus.authors = $scope.authors.map(a => a._id);
                // $scope.syllabus.lecturers = $scope.lecturers.map(a => a._id);
                SyllabusService.save({
                    subjectId: $scope.subjectId,
                    syllabus: $scope.syllabus
                }).then(function (data) {
                    if (data) {
                        loadPage();
                        toastr.success('', 'რედაქტირების მოთხოვნა გაგზავნილია');
                        usSpinnerService.stop("root");
                    } else {
                        toastr.error('', 'დაფიქსირდა შეცდომა');
                    }
                });
            }
        };

        function loadAuthors() {
            $scope.syllabus.authors.forEach(function (authorId) {
                Lecturer.fetchOne(authorId).then(function (data) {
                    $scope.authors.push(data);
                });
            })
        }

        // function loadLecturers() {
        //     $scope.syllabus.lecturers.forEach(function (lecturerId) {
        //         Lecturer.fetchOne(lecturerId).then(function (data) {
        //             $scope.lecturers.push(data);
        //         });
        //     })
        // }

        function reload() {
            // $scope.lecturers = [];
            $scope.authors = [];
            $scope.loaded = false;
            if ($scope.syllabus && $scope.syllabus.authors) {
                loadAuthors($scope.syllabus.authors);
            }
            // if($scope.syllabus.lecturers) {
            //     loadLecturers($scope.syllabus.lecturers);
            // }
            $timeout(function () {
                $scope.loaded = true;
            }, 10)
        }

        $scope.getLastVersion = function () {
            $scope.syllabus = $scope.data;
            $scope.myVersion = false;
            if ($scope.data.editRequest) {
                $scope.tinymceOptions = $scope.disabledTiny;
            } else {
                $scope.tinymceOptions = $scope.enabledTiny;
            }
            reload();
        };

        $scope.getMyVersion = function () {
            $scope.syllabus = $scope.data.editRequest;
            $scope.myVersion = true;
            if ($scope.action == 'edit') {
                $scope.tinymceOptions = $scope.enabledTiny;
            } else {
                $scope.tinymceOptions = $scope.disabledTiny;
            }
            reload();
        };

        $scope.approve = function (request, $event) {
            ConfirmModal.show({
                title: "დაშვება",
                message: "გსურთ ამ ცვლილების დაშვება?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                SyllabusService.approve({
                    _id: $scope.syllabus._id,
                    approved: true
                }).then(function (res) {
                    usSpinnerService.stop("root");
                    toastr.success('ცვლილება დაშვებულია ');
                    $state.go('admin.syllabus-control', {});
                })
            });
        };

        $scope.deny = function (request, $event) {
            ConfirmModal.show({
                title: "უარყოფა",
                message: "არ გსურთ ამ ცვლილების უარყოფა?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                SyllabusService.approve({
                    _id: $scope.syllabus._id,
                    approved: false
                }).then(function () {
                    usSpinnerService.stop("root");
                    toastr.success('ცვლილება უარყოფილია ');
                    $state.go('admin.syllabus-control', {});
                })
            });
        };

        $scope.prepareFields = function () {
            AuthService.getUserData().then(function (user) {
                var lecturerProfile = user.profiles ? user.profiles.find(function (p) { return p.type == 'lecturer' }) : {}
                var disable = false;
                var authors = $scope.syllabus && $scope.syllabus.authors ? $scope.syllabus.authors : []
                if ($scope.action == 'review') {
                    disable = true;
                } else {

                    if ($scope.myVersion) return;
                    var hasright = AuthService.hasRight('manage-subject-syllabus-sudo');

                    if (hasright) {
                        $scope.disableFields = false;
                        return;
                    }

                    var isAuthor = authors.find(function (a) {
                        return a.indexOf(lecturerProfile._id) > -1
                    });

                    if (isAuthor) disable = false;
                    else disable = true

                }
                $scope.disableFields = disable;
            })
        };


        $scope.changeDialog = function (before, after) {
            // var syllabus = $scope.syllabus;
            $uibModal.open({
                controller: "ChangeCompareController",
                templateUrl: _pb + 'admin/subject/change-compare.html',
                size: "xl",
                windowClass: "biggest",
                resolve: {
                    oldText: function () {
                        return before;
                    },
                    newText: function () {
                        return after;
                    }
                }
            }).result
                .then(function (result) {
                    // loadPage($scope.currentPage);
                }, function () {
                });


        }

        Array.prototype.equals = function (array) {
            if (!array) return false;
            if (this.length != array.length) return false;

            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array && array[i] instanceof Array) {
                    if (!this[i].equals(array[i]))
                        return false;
                }
                else if (this[i] != array[i]) {
                    return false;
                }
            }
            return true;
        };
    }
]);
